<template>
  <div
    class="sidebar"
    :data-background-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <!--
            Tip 1: you can change the color of the sidebar's background using: data-background-color="white | black | darkblue"
            Tip 2: you can change the color of the active button using the data-active-color="primary | info | success | warning | danger"
        -->
    <!-- -->
    <div class="sidebar-wrapper" id="style-3">
      <div class="logo">
        <a href="#" class="simple-text">

          <div  class="avatar justify-content-center align-content-center d-flex" style="margin-top: -30px;">
            <img  :src="foto" alt="" style="width:250px" />
          </div>

          <div v-if="auth"  class="avatar justify-content-center align-content-center d-flex mt-3">
            <img
              style="width: 90px; height: 90px; border-radius: 50%;"
              class="avatar border-white"
              :src="rutaApp +'storage/documents/' + auth.Foto"
              alt="..."
            />
          </div>
        </a>
        <div v-if="!auth" class="text-center" style="font-family: Arial, sans-serif; font-size: 12px; ">
            <b>{{ title }}</b>
          </div>
          <div v-else class="text-center" style="font-family: Arial, sans-serif; font-size: 12px; color: #003f8a !important; font-weight: 500;">
            <b>{{ auth.Persona }}</b>
          </div>
      </div>
  
      <slot></slot> 

      
      <ul class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot name="links">
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="index"
            :to="link.path"
            :name="link.name"
            :icon="link.icon"
          >
          </sidebar-link>
        </slot>
      </ul>
      <moving-arrow :move-y="arrowMovePx"> </moving-arrow>
    </div>
  </div>
</template>
<script>
import MovingArrow from "./MovingArrow.vue";
import SidebarLink from "./SidebarLink";
export default {
  props: {
    title: {
      type: String,
      default: "Menú de Navegación",
    },
    backgroundColor: {
      type: String,
      default: "white",
      validator: (value) => {
        let acceptedValues = ["white", "black", "darkblue"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "primary",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    };
  },
  components: {
    MovingArrow,
    SidebarLink,
  },
  computed: {
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    },
  },
  data() {
    return {
      linkHeight: 65,
      rutaApp:process.env.VUE_APP_RRHH_SERVICE,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],
      auth:{},
      foto : '',
      sistemas : [
        { id: 25, descripcion: "EMINEWS" },
        { id: 24, descripcion: "SISCUP" },
        { id: 29, descripcion: "SIDEC" },
        { id: 26, descripcion: "EXPOEMI" },
        { id: 1, descripcion: "SIACT" },
        { id: 3, descripcion: "SISAS" },
        { id: 22, descripcion: "SISAR" },
        { id: 21, descripcion: "MIS SISTEMAS" },
        { id: 23, descripcion: "SISNIGE" },
        { id: 27, descripcion: "SIPLA" },
        { id: 2, descripcion: "SISAL" },
        { id: 28, descripcion: "SGD.gif" },
        { id: 7, descripcion: "SISDEP.gif" },
        { id: 8, descripcion: "SISCER" },
        { id: 15, descripcion: "SISPRO.gif" },
        { id: 9, descripcion: "SISTG.gif" },
        { id: 16, descripcion: "SISGAP.gif" },
        { id: 18, descripcion: "SISREG.gif" },
        { id: 13, descripcion: "SKG.gif" },
        { id: 4, descripcion: "SISBLI.gif" },
        { id: 17, descripcion: "SISGP.gif" },
        { id: 19, descripcion: "SISREP.gif" },
        { id: 14, descripcion: "SISPOA.gif" },
        { id: 5, descripcion: "CORRESPONDENCIA -EMI" },
        { id: 12, descripcion: "JDC" },
        { id: 32, descripcion: "SISDC.gif" },
        { id: 6, descripcion: "SISDEG.gif" },
        { id: 30, descripcion: "SUGEMI" },
        { id: 11, descripcion: "SIRESI" },
        { id: 31, descripcion: "CIBEREMI" },
        { id: 10, descripcion: "SIPRE" },
        { id: 34, descripcion: "SISIR" },
        { id: 33, descripcion: "SISIR" },
        { id: 37, descripcion: "SISNOTAS" },
        { id: 38, descripcion: "SAGA" },
        { id: 39, descripcion: "SISNG" },
        { id: 40, descripcion: "SISRPOS" },
        { id: 42, descripcion: "JDC-GRADO" },
        { id: 36, descripcion: "SISPOA.gif" },
        { id: 20, descripcion: "SIPDEA.gif" },
        { id: 41, descripcion: "SISCUR.gif" },
        { id: 35, descripcion: "SISING.gif" }
      ]
    };
  },
  methods: {
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index;
        }
      });
    },
    addLink(link) {
      const index = this.$slots.links.indexOf(link.$vnode);
      this.links.splice(index, 0, link);
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },

    actutalizaridSistema(query){
      const idSistema = this.$route.query.id;
      const sistemaE = this.sistemas.find(item => item.id == idSistema);
      //this.foto = require(`@/assets/img/${sistemaE.descripcion}`);
      //console.log(this.foto);
    }

  },
  mounted() {

    this.foto = require(`@/assets/img/SAGAINT.gif`);
    console.log(this.foto);
    this.auth = JSON.parse(localStorage.getItem('usuario'));
    console.log(this.auth);
    this.$watch("$route", this.findActiveLink, {
      immediate: true,
    });
  },

  watch: {
    // Observar los cambios en la ruta
    '$route.query': {
      handler(newQuery) {
        // Cuando cambien los parámetros de la ruta, actualizamos el sistema
        this.actutalizaridSistema(newQuery);
      },
      immediate: true // Ejecutar inmediatamente al cargar el componente
    }
  },
};
</script>
<style></style>
